import { HttpService } from '@Services/api/httpService.ts';
import { useBoundStore } from '@Store/useBoundStore.ts';
import { OnboardingFlowIdentifier } from '@Types/onboarding.types.ts';
import { identifyLogRocketUser } from '@Services/analytics/logrocket.service';
import { NAVIGATION_STACK_VERSION } from '@Types/consts';
import { redirectToWebAppLoginPage } from '../../../utils';
import type { IAuthUserLastStep } from '@Store/slices/authOnboarding/authOnboarding.types';

const fetchAuthUserLastStep = async (
  customerId: string,
  authorizedUserId: string
): Promise<IAuthUserLastStep | null> => {
  try {
    const { data } = await HttpService.get<IAuthUserLastStep>(
      `v3/onboarding/user/${customerId}/authorized/user/${authorizedUserId}/step`,
      { params: { version: String(NAVIGATION_STACK_VERSION) } }
    );
    return data;
  } catch {
    return null;
  }
};

export const handleAuthUserFlowInitialData = async (
  customerId: string,
  authorizedUserId: string
) => {
  const setAuthOnboardingData = useBoundStore.getState().setAuthOnboardingData;
  const setOnboardingIdentifier = useBoundStore.getState().onboardingSlice.setOnboardingIdentifier;

  const [{ data }, lastStepData] = await Promise.all([
    HttpService.get(`v3/onboarding/user/${customerId}/authorized/user/${authorizedUserId}`),
    fetchAuthUserLastStep(customerId, authorizedUserId),
  ]);

  const loginToken = useBoundStore.getState().onboardingSlice.loginToken;
  if (data.onboardingType === 'NOT_NEEDED' && !loginToken) {
    redirectToWebAppLoginPage();
    return true;
  }

  setAuthOnboardingData({ ...data, lastStepData });

  if (data.phoneNumber) {
    const customerDataToUpdate = useBoundStore.getState().getCustomerData();
    customerDataToUpdate.customerData.phoneNumber = data.phoneNumber;
    useBoundStore.getState().setCustomerData(customerDataToUpdate);
  }

  setOnboardingIdentifier(OnboardingFlowIdentifier.AUTHORIZED_USER);
  identifyLogRocketUser(authorizedUserId, {
    authorizedUserType: data.authorizedUserType,
    primaryCustomerId: customerId,
  });
  return false;
};
